import './css/_app.scss';
import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './components/Home';

import AboutUs from './components/AboutUs';
import RoomSuits from './components/RoomSuits';
import Services from './components/Services';
import Locations from './components/subComponents/Locations';

function App() {
  return (
    <Router>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/home" element={<Home />} />
        <Route path="/rooms" element={<RoomSuits />} />
        <Route path="/services" element={<Services />} />
        <Route path="/locations/:locationPath" element={<Locations />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
